// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"BulletsCurationSection_sectionContainer__1YqNa","categoryListContainer":"BulletsCurationSection_categoryListContainer__icvcm"};